import { render, staticRenderFns } from "./HelpList.vue?vue&type=template&id=3c4ab7d7&"
import script from "./HelpList.vue?vue&type=script&lang=js&"
export * from "./HelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports